import http from '../http-common';

const getAll = () => {
    return http.get(`/v1/web-config/`);
};

const get = (id) => {
    return http.get(`/v1/web-config/${id}`);
};

const create = (data) => {
    return http.post('/v1/web-config', data);
};

const update = (id, data) => {
    return http.put(`/v1/web-config/${id}`, data);
};

const remove = (id) => {
    return http.delete(`/v1/web-config/${id}`);
};

const removeAll = () => {
    return http.delete(`/v1/web-config`);
};

export default {
    getAll,
    get,
    create,
    update,
    remove,
    removeAll,
};
